'use client';

import { Badge, TextLink } from '@petsmart-ui/sparky';

import { useStore, useStoreDispatch } from '@libs/common-next';

import type { StoreItemProps } from '@/components/StoreDirectory';

export default function MyStoreBadge({ store }: Readonly<StoreItemProps>) {
    const { selectedStore } = useStore();
    const { updateSelectedStore } = useStoreDispatch();

    const showBadge = String(store.StoreNumber) === String(selectedStore.data?.StoreNumber);
    const setMyStore = () => {
        // update local storage and user session state and do optimistic rendering
        updateSelectedStore(store.StoreNumber);
    };

    if (showBadge) {
        return <Badge text="My store" />;
    }

    return <TextLink onClick={setMyStore}>Set as my store</TextLink>;
}
